export var valuesPostTypeEnum = ["Undefined", "Briefing", "Content", "GenericPost", "News", "PorscheMoment"];
/*

*/ 
//# sourceMappingURL=PostTypeEnum.js.map